/**
 * Unions Catalog Service
 */

import { apiClient } from '@/api/core/apiClient.ts';
import { API_CONFIG } from '@/api/core/apiConfig.ts';
import type { ApiResponse } from '@/api/shared/types.ts';
import type { LC_GetUnionsOut, Union } from './unions.types.ts';
import { mapUnionOutToModel } from './unions.mapper.ts';


export class UnionsCatalogService {
  /**
   * Get available unions for the authenticated user's company
   */
  async getUnions(): Promise<ApiResponse<Union[]>> {
    const response = await apiClient.get<LC_GetUnionsOut>(
      API_CONFIG.ENDPOINTS.CATALOG.UNIONS,
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapUnionOutToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const unionsCatalogService = new UnionsCatalogService();
